/**
 * Quadra Wishlist
 * Gestione globale tramite cookie
 */

(function () {
  if (window.QuadraWishlistInitialized) return;
  window.QuadraWishlistInitialized = true;

  const COOKIE_NAME = 'shopify_wishlist';
  const COOKIE_DURATION = 2592000; // 30 giorni

  function getWishlist() {
    try {
      const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(COOKIE_NAME + '='));

      if (!cookie) return [];

      const value = cookie.substring(COOKIE_NAME.length + 1);
      const parsed = JSON.parse(decodeURIComponent(value));

      return Array.isArray(parsed)
        ? [...new Set(parsed)]
        : [];
    } catch (error) {
      console.error('Wishlist: errore lettura cookie', error);
      return [];
    }
  }

  function saveWishlist(list) {
    const cleanList = [...new Set(list)];

    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(JSON.stringify(cleanList)) +
      ';path=/' +
      ';max-age=' +
      COOKIE_DURATION +
      ';SameSite=Lax';

    return cleanList;
  }

  function has(handle) {
    return !!handle && getWishlist().includes(handle);
  }

  function dispatchUpdate(handle, active) {
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          handle: handle,
          active: active,
          wishlist: getWishlist()
        }
      })
    );
  }

  function add(handle) {
    if (!handle) return false;

    const list = getWishlist();

    if (!list.includes(handle)) {
      list.push(handle);
      saveWishlist(list);
    }

    dispatchUpdate(handle, true);
    return true;
  }

  function remove(handle) {
    if (!handle) return false;

    const list = getWishlist().filter(
      item => item !== handle
    );

    saveWishlist(list);
    dispatchUpdate(handle, false);

    return false;
  }

  function toggle(handle) {
    if (!handle) return false;

    return has(handle)
      ? remove(handle)
      : add(handle);
  }

  function syncButtons() {
    const wishlist = getWishlist();

    const buttons = document.querySelectorAll(
      '.cpc-wishlist[data-product-handle], ' +
      '.cq-wishlist-btn[data-product-handle]'
    );

    buttons.forEach(function (button) {
      const handle = button.getAttribute(
        'data-product-handle'
      );

      if (!handle) return;

      const active = wishlist.includes(handle);

      button.classList.toggle(
        'is-active',
        active
      );

      button.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

      button.setAttribute(
        'aria-label',
        active
          ? 'Rimuovi dai preferiti'
          : 'Aggiungi ai preferiti'
      );
    });
  }

  function animateHeart(button) {
    if (!button.classList.contains('cpc-wishlist')) {
      return;
    }

    button.classList.remove('is-animating');

    void button.offsetWidth;

    button.classList.add('is-animating');

    setTimeout(function () {
      button.classList.remove('is-animating');
    }, 360);
  }

  window.Wishlist = {
    cookieName: COOKIE_NAME,
    get: getWishlist,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    sync: syncButtons
  };

  /*
   * Listener in CAPTURE.
   *
   * In questo modo il cuore funziona anche dentro caroselli
   * o componenti che intercettano il click durante il bubbling.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest(
        '.cpc-wishlist[data-product-handle], ' +
        '.cq-wishlist-btn[data-product-handle]'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.getAttribute(
        'data-product-handle'
      );

      if (!handle) return;

      const active = toggle(handle);

      syncButtons();

      if (active) {
        animateHeart(button);
      }
    },
    true
  );

  document.addEventListener(
    'wishlist:updated',
    syncButtons
  );

  document.addEventListener(
    'cpc:card-replaced',
    syncButtons
  );

  document.addEventListener(
    'shopify:section:load',
    syncButtons
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncButtons
    );
  } else {
    syncButtons();
  }
})();